import { Component, OnInit,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../service/data.service';
import { UserService } from '../service/user.service';
import { User } from '../_models/user';
import { AlertService } from '../service/alert.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BotDetectCaptchaModule } from 'angular-captcha';
import { CaptchaComponent } from 'angular-captcha';

import { MyDatePickerModule ,IMyInputFocusBlur} from 'mydatepicker';
import { NgModule, ViewChild } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {IMyDpOptions, IMyDateModel, IMyOptions} from 'mydatepicker';
import { Observable } from 'rxjs';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpClient } from '@angular/common/http';

declare var getHexAscii: any;
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  providers: [DataService]
})
export class ForgotPasswordComponent implements OnInit {
  page1:Boolean;
  page2:Boolean;
  page3:Boolean;
  nextpage=true;
  returnUrl: string;
  forgotform: FormGroup;
  msgforcustnoonly:string;
  msgforCustNoSpace:string;
  msgforCustNoSplChar:string;
  messageForAccNoreq:string;
  msgforAccNoSpace:string;
  msgForDateRequired:string;
  msgforAccNoSplChar:string;
  msgforAccnNonly:string;
  msgforAccNoLen:string;
  messageFormMobNoreq:string;
  msgforMobNoSpace:string;
  msgforMobNoSplChar:string;
  msgforMobNonly:string;
  msgforMobNoLen:string;
  messageNewUserreq:string;
  msgforNewUserNoSpace:string;
  messageFormNewPassreq:string;
  msgforNewPassSplChar:string;
  msgforNewPassLen:string;
  messageForOneCapital:string;
  messageForOneNumber:string;
  msgforNewPassSpace:string;
  msgConfPassrequired:string;
  confpassNotMatch:string;
  messageForcustnumber:string;
  messageForCaptchareq:string;
  msgOtprequired:string;
  captchatNoblank:string;
  incorrectCaptcha:string;
  regsplchar=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regchar='/^[a-zA-Z]+$/';
  regexpspace=/\s+/;
  regZeroOnly='^[0][0]*[0]$';
  regNum = '^[0-9]*$';
  regOneNum = '.*[0-9].*';
  regexcap =/^.*?[A-Z]/;
  Errorflag:string="no";
  Errorflag1:string="no";
  Errorflag2:string="no";
  isError = 'false';
  errorDescription = ' ';
  isLoad = false;
  placeholder: string;
  isError1:string;
  Errorflagcap:string="no";
  Errorflaguser:string="no";
  Errorflagcust:string="no";
  Errorflagmob:string="no";
  Errorflagdate:string="no";
  ErrorflagNewPass:string="no";
  ErrorflagOtp:string='no';
  msgOtpNoSpace:string='';
  ErrorflagConfPass:string="no";
  isDisabled2: boolean = false;
  mytime:Date = new Date();
  isDisabled : boolean = false;
  currentYear:any= this.mytime.getUTCFullYear();
  currentDate:any= this.mytime.getUTCDate()+1;
  currentMonth:any= this.mytime.getUTCMonth() + 1;
  myDatePickerOptions: IMyDpOptions = {
    inline: false,
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
    disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate}
  };
  invalidOtp: string;
  otp: string;
  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum1 = /^[0-9]+$/;
  bankName: any;
  contactUsPage: string;
  atmBranch: string;

  constructor(private router: Router,
              private fb: FormBuilder,
              private userService: UserService,
              private route: ActivatedRoute,
              private webService: CallBackEndService,
              private spinnerService: Ng4LoadingSpinnerService,
              private alertService: AlertService,private http: HttpClient) { 

                this.bankName = this.webService.getBankName();

                this.getJSON().subscribe(data => {
                  this.atmBranch = data.atmBranch;
                  this.contactUsPage = data.contactUsPage;
                 });    
                  

    this.page1=true;
    this.page2=false;
    this.page3=true;
    this.nextpage=true;
    this.Errorflag="no";
    this.Errorflag1="no";
    this.Errorflag2="no";
    this.Errorflagcap="no";
    this. Errorflaguser="no";
    this. Errorflagcust="no";
    this. Errorflagmob="no";
    this. Errorflagdate="no";
    this. ErrorflagNewPass="no";
    this. ErrorflagConfPass="no";
    this.ErrorflagOtp="no";

    this.forgotform = fb.group({
      'username' : [null, Validators.required],
      'customerNo' : [null, Validators.required],
      'mobNo' : [null, Validators.required],
      'date' : [null, Validators.required],
      'captchaInput' : [null, Validators.required],
      'captcha' : [null, Validators.required],
      'newPassword' : [null, Validators.required],
      'confirmPassword' : [null, Validators.required],
      'otp' : [null, Validators.required],

    });
    this.getCaptcha();
  }
  public getJSON(): Observable<any> {
    return this.http.get('assets/SampleUrl.json');
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/show-success';
    this.changePlaceholder();

  }
  openPage1(){
    this.page1=true;
    this.page2=false;
    this.nextpage=true;
    this.errorDescription ="";
    this.getCaptcha();
    this.forgotform.get("captchaInput").reset();
    this.Errorflagcap='no';

  }
  openPage2()
  {
    this.errorDescription='';
     let newuser=this.forgotform.controls['username'];
     let custno=this.forgotform.controls['customerNo'];
     let mobno1=this.forgotform.controls['mobNo'];
      let captcha=this.forgotform.controls['captchaInput'];
      let date1=this.forgotform.controls['date'];
    let date2=date1.value;
    let captchaWithoutSpaceNew = this.forgotform.controls['captcha'].value.split(' ').join('');
    if (newuser.value === '' ||newuser.value===' ' ||newuser.value===undefined||newuser.value===null)
    {
      this.messageNewUserreq = 'no';
      this. Errorflaguser='no';

    }else if(newuser.value.match(this.regexpspace))
    {
      this.msgforNewUserNoSpace='no';
      this. Errorflaguser='no';
    }else  if (custno.value === '' ||custno.value===' '||custno.value===undefined||custno.value===null)
    {
      console.log("In iff"+custno.value);
      this.messageForcustnumber = 'no';
      this.Errorflagcust="no";

    }else if(custno.value.match(this.regexpspace))
    {
      this.msgforCustNoSpace= 'no';
      this.Errorflagcust="no";
    }else if(custno.value.match(this.regsplchar))
    {
      this.msgforCustNoSplChar= 'no';
      this.Errorflagcust="no";
    }else if(!custno.value.match(this.regNum))
    {
      this.msgforcustnoonly = 'no';
      this.Errorflagcust="no";
    } else
    if (mobno1.value === '' ||mobno1.value===' ' ||mobno1.value===undefined||mobno1.value===null)
    {
      this.messageFormMobNoreq = 'no';
      this.Errorflagmob="no";

    }else if(mobno1.value.match(this.regexpspace))
    {
      this.msgforMobNoSpace= 'no';
      this.Errorflagmob="no";
    }else if(mobno1.value.match(this.regsplchar))
    {
      this.msgforMobNoSplChar= 'no';
      this.Errorflagmob="no";
    }else if(!mobno1.value.match(this.regNum))
    {
      this.msgforMobNonly = 'no';
      this.Errorflagmob="no";
    }else if(mobno1.value.length>10||mobno1.value.length<10)
    {
      this.msgforMobNoLen = 'no';
      this.Errorflagmob="no";
    }else  if (date2==='""'||date2==='" "'||date2==='"  "' ||date2===undefined||date2===null)
    {
      this.msgForDateRequired = 'no';
      this.Errorflagdate="no";
    }else
    if (captcha.value === '' ||captcha.value===' ' ||captcha.value===undefined||captcha.value===null)
    {
      this.captchatNoblank = 'no';
      this.Errorflagcap="no";
    }else if(captcha.value!==captchaWithoutSpaceNew)
    {
      this.incorrectCaptcha='no';
      this.Errorflagcap="no";
    }else{
  



  //   this.page2=true;
  //   this.page1=false;
  //   this.nextpage=true;
  //   this.errorDescription ="";
  //   console.log("Page2---"+ this.page2);
  //   this.isDisabled=false;
  //  this.forgotform.controls['newPassword'].setValue('');
  // this.forgotform.controls['confirmPassword'].setValue('');



  //this.isDisabled = true ;
  this.spinnerService.show();
 // console.log("on submit");
  const request: IbRequest = new IbRequest();
  let response: IbResponse = null;
  this.isLoad = true;
  this.errorDescription ="";
  let date1=this.forgotform.controls['date'];
  let date2=date1.value;
  request.param5=date2['date'].day+"-"+this.getMonthName(date2['date'].month)+"-"+date2['date'].year;
  request.param1 = getHexAscii('', this.forgotform.get("username").value+this.forgotform.get("customerNo").value+this.forgotform.get("mobNo").value+request.param5);
  request.param2 = this.forgotform.get("username").value;
  request.param3 = this.forgotform.get("customerNo").value;
  request.param4 = this.forgotform.get("mobNo").value;
  //request.param5 =date2['formatted'];

  // console.log("param5---"+request.param5);
  this.webService.getResponse(request, 'validateForgotPasswordPage1').subscribe((data: IbResponse) => {
    response = data;
      this.spinnerService.hide();
    if (response.status === 'S200') {
      // this.page2=false;
      // this.page1=false;
      // this.nextpage=false;
      this.page2=true;
    this.page1=false;
    this.nextpage=true;
    this.errorDescription ="";
    console.log("Page2---"+ this.page2);
    this.isDisabled=false;
   this.forgotform.controls['newPassword'].setValue('');
  this.forgotform.controls['confirmPassword'].setValue('');
    } else if (response.status === 'S101') {
      alert('Malicious Request Detected');
      this.isLoad = false;
    } else {
      this.isError = 'errorFromBackend';
     // this.isDisabled = false ;
      // tslint:disable-next-line:no-unused-expression
      response.statusDescription;
      this.errorDescription = response.param1;
      this.page1=true;
      //this.isLoad = false;
    }
  });
  
    }
  }
  openPage2back()
  {
    this.page2=true;
    this.page1=false;
    this.nextpage=true;
    this.errorDescription ="";
    this.isDisabled=false;

  }
  openPage3(){
 let newPass=this.forgotform.controls['newPassword'];
 let newpass:string=this.forgotform.controls['newPassword'].value;
    let confpass:string=this.forgotform.controls['confirmPassword'].value;
    if (newPass.value === '' ||newPass.value===' ' ||newPass.value===undefined||newPass.value===null)
    {
      this.messageFormNewPassreq = 'no';
      this.ErrorflagNewPass="no";

    }else if(newPass.value.match(this.regexpspace))
    {
      this.msgforNewPassSpace= 'no';
      this.ErrorflagNewPass="no";
    }else if(!newPass.value.match(this.regsplchar))
    {
      this.msgforNewPassSplChar= 'no';
      this.ErrorflagNewPass="no";
    }else if(newPass.value.length<8)
    {
      this.msgforNewPassLen = 'no';
      this.ErrorflagNewPass="no";
    }else if(newPass.value.length>16)
    {
      this.msgforNewPassLen = 'no';
      this.ErrorflagNewPass="no";
    }
    else if(!newPass.value.match(this.regexcap))
    {
      this.messageForOneCapital='no';
      this.ErrorflagNewPass="no";

    }
    else if(!newPass.value.match(this.regOneNum))
    {
      this.messageForOneNumber='no';
      this.ErrorflagNewPass="no";

    }else 
    if (this.forgotform.controls['confirmPassword'].value === '' ||this.forgotform.controls['confirmPassword'].value===' ' ||this.forgotform.controls['confirmPassword'].value===undefined||this.forgotform.controls['confirmPassword'].value===null)
    {
      this.msgConfPassrequired='no';
      this.Errorflag1="no";
    }else if(!(newpass===confpass))
    {
      this.confpassNotMatch='no';
      this.ErrorflagConfPass="no";

    }else{
    this.isDisabled = true ;
    this.spinnerService.show();
    console.log("on submit");
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    this.isLoad = true;
    this.errorDescription ="";
    let date1=this.forgotform.controls['date'];
    let date2=date1.value;
    request.param5=date2['date'].day+"-"+this.getMonthName(date2['date'].month)+"-"+date2['date'].year;
    request.param1 = getHexAscii('', this.forgotform.get("username").value+this.forgotform.get("customerNo").value+this.forgotform.get("mobNo").value+request.param5);
    request.param2 = this.forgotform.get("username").value;
    request.param3 = this.forgotform.get("customerNo").value;
    request.param4 = this.forgotform.get("mobNo").value;
    //request.param5 =date2['formatted'];

    console.log("param5---"+request.param5);
    this.webService.getResponse(request, 'forgotPassword').subscribe((data: IbResponse) => {
      response = data;
        this.spinnerService.hide();
      if (response.status === 'S200') {
        //sessionStorage.setItem('ForgotUserScss', response.param1);
        this.page2=false;
        this.page1=false;
        this.nextpage=false;
        this.errorDescription ='';
        this.invalidOtp='';
        this.forgotform.get("otp").reset();
        // console.log('otp value in advance----------------'+this.otp);
        
        // this.router.navigate([this.returnUrl]);
      } else if (response.status === 'S101') {
        alert('Malicious Request Detected');
        this.isLoad = false;
      } else {
        this.isError = 'true';
        this.isDisabled = false ;
        // tslint:disable-next-line:no-unused-expression
        response.statusDescription;
        this.errorDescription = response.param1;
        this.isLoad = false;
      }
    });
  }
  }
  clearForm()
  {
    // this.forgotform.setValue({custnumber: '',accno: '',mobno: '',date:'',captcha: '',password:''});
    this.forgotform.get("username").reset();
    this.forgotform.get("date").reset();
    this.forgotform.get("mobNo").reset();
    this.forgotform.get("captchaInput").reset();
    this.forgotform.get("customerNo").reset();
    this.msgForDateRequired='';
  }
  forgotpassSubmit()
  {
  //   let otp=this.forgotform.controls['otp'];
  //   if (otp.value === '' ||otp.value===' ' ||otp.value===undefined||otp.value===null)
  //   {
  //     this.msgOtprequired = 'no';
  //     this.ErrorflagOtp="no";

  //   }else if (otp.value.match(this.regexpspace))
  //   {
  //     this.msgOtpNoSpace = 'no';
  //     this.ErrorflagOtp="no";

  //   } 
  //  else
    if(this.validateOtp()) {
    this.isDisabled2=true;
    this.spinnerService.show();
    console.log("on submit");
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    this.isLoad = true;

    request.param1 = getHexAscii('', this.forgotform.get("username").value+this.forgotform.get("confirmPassword").value+this.forgotform.get("otp").value+this.forgotform.get("customerNo").value);
    request.param2 = this.forgotform.get("username").value;
    request.param3= this.forgotform.get("confirmPassword").value;
    request.param4 = this.forgotform.get("otp").value;
    request.param5 = this.forgotform.get("customerNo").value;
    console.log("param---"+request.param2+"@@"+request.param4);
    this.webService.getResponse(request, 'changePassword').subscribe((data: IbResponse) => {
      response = data;
        this.spinnerService.hide();
      if (response.status === 'S200') {
       sessionStorage.setItem('showSuccessMsg', response.param1);
        this.router.navigate([this.returnUrl]);
      } else if (response.status === 'S101') {
        alert('Malicious Request Detected');
        this.isLoad = false;
      } else {
        this.isError1 = 'true';
        this.isDisabled2=false;
        // tslint:disable-next-line:no-unused-expression
        response.statusDescription;
        this.errorDescription = response.param1;
        this.isLoad = false;
      }
    });
  }

  }

  goToLink1(){
    //  window.open('http://www.abhinavbank.com/branch.asp','_blank');
    window.open(this.atmBranch,'_blank');

    //window.location.href='#/Disclaimer';
  }
  goToLink2(){
    // window.open('https://www.maheshbankpune.in/contact-us.html','_blank');
    // window.open('http://www.abhinavbank.com/contact.asp','_blank'); 
    window.open(this.contactUsPage,'_blank'); 

  }

  validateConfPassword()
  {
    let newpass:string=this.forgotform.controls['newPassword'].value;
    let confpass:string=this.forgotform.controls['confirmPassword'].value;
    if (this.forgotform.controls['confirmPassword'].value === '' ||this.forgotform.controls['confirmPassword'].value===' ' ||this.forgotform.controls['confirmPassword'].value===undefined||this.forgotform.controls['confirmPassword'].value===null)
    {
      this.msgConfPassrequired='no';
      this.Errorflag1="no";
    }else if(!(newpass===confpass))
    {
      this.confpassNotMatch='no';
      this.ErrorflagConfPass="no";

    }else{
      this.ErrorflagConfPass="yes";
    }

  }
  clearConfPassword()
  {
    this.msgConfPassrequired='';
    this.confpassNotMatch='';

  }


  validateCustNo()
  {

    console.log("in validation");
    let custno=this.forgotform.controls['customerNo'];
    if (custno.value === '' ||custno.value===' '||custno.value===undefined||custno.value===null)
    {
      console.log("In iff"+custno.value);
      this.messageForcustnumber = 'no';
      this.Errorflagcust="no";

    }else if(custno.value.match(this.regexpspace))
    {
      this.msgforCustNoSpace= 'no';
      this.Errorflagcust="no";
    }else if(custno.value.match(this.regsplchar))
    {
      this.msgforCustNoSplChar= 'no';
      this.Errorflagcust="no";
    }else if(!custno.value.match(this.regNum))
    {
      this.msgforcustnoonly = 'no';
      this.Errorflagcust="no";
    }else{
      this.Errorflagcust='yes';
    }
    console.log("Errorflag-----------"+this.Errorflagcust);

  }
  clearCustNo()
  {
    this.messageForcustnumber='';
    this.msgforcustnoonly = '';
    this.msgforCustNoSplChar='';
    this.msgforCustNoSpace= '';
    this.isError = '';
  }
  validateAccNO()
  {
    let accno1=this.forgotform.controls['accno'];
    if (accno1.value === '' ||accno1.value===' ' ||accno1.value===undefined||accno1.value===null)
    {
      this.messageForAccNoreq = 'no';
      this.Errorflag="no";

    }else if(accno1.value.match(this.regexpspace))
    {
      this.msgforAccNoSpace= 'no';
      this.Errorflag="no";
    }else if(accno1.value.match(this.regsplchar))
    {
      this.msgforAccNoSplChar= 'no';
      this.Errorflag="no";
    }else if(!accno1.value.match(this.regNum))
    {
      this.msgforAccnNonly = 'no';
      this.Errorflag="no";
    }else if(accno1.value.length>15||accno1.value.length<15)
    {
      this.msgforAccNoLen = 'no';
      this.Errorflag="no";
    }
    else{
      this.Errorflag='yes';
    }
    console.log("Errorflag-----------"+this.Errorflag);
  }

  clearAccNo()
  {
    this.messageForAccNoreq = '';
    this.msgforAccNoSpace='';
    this.msgforAccNoSplChar='';
    this.msgforAccnNonly='';
    this.msgforAccNoLen='';
  }
  validateMobNO()
  {
    console.log("mob no.");
    let mobno1=this.forgotform.controls['mobNo'];
    if (mobno1.value === '' ||mobno1.value===' ' ||mobno1.value===undefined||mobno1.value===null)
    {
      this.messageFormMobNoreq = 'no';
      this.Errorflagmob="no";

    }else if(mobno1.value.match(this.regexpspace))
    {
      this.msgforMobNoSpace= 'no';
      this.Errorflagmob="no";
    }else if(mobno1.value.match(this.regsplchar))
    {
      this.msgforMobNoSplChar= 'no';
      this.Errorflagmob="no";
    }else if(!mobno1.value.match(this.regNum))
    {
      this.msgforMobNonly = 'no';
      this.Errorflagmob="no";
    }else if(mobno1.value.length>10||mobno1.value.length<10)
    {
      this.msgforMobNoLen = 'no';
      this.Errorflagmob="no";
    }
    else{
      this.Errorflagmob='yes';
    }
    console.log("Errorflag-----------"+this.Errorflag);
  }

  clearMobNo()
  {
    this.messageFormMobNoreq='';
    this.msgforMobNoSpace='';
    this.msgforMobNoSplChar='';
    this.msgforMobNonly='';
    this.msgforMobNoLen='';
    this.isError = '';
  }

  validateNewUserName()
  {
    let newuser=this.forgotform.controls['username'];
    if (newuser.value === '' ||newuser.value===' ' ||newuser.value===undefined||newuser.value===null)
    {
      this.messageNewUserreq = 'no';
      this. Errorflaguser='no';

    }else if(newuser.value.match(this.regexpspace))
    {
      this.msgforNewUserNoSpace='no';
      this. Errorflaguser='no';
    }else{
      this. Errorflaguser='yes';
    }

  }
  clearNewUserName()
  {
    this.messageNewUserreq='';
    this.msgforNewUserNoSpace='';
    this.isError='';
    console.log('isError value : '+this.isError);
  }

  validateNewPassword()
  {
    let newPass=this.forgotform.controls['newPassword'];
    if (newPass.value === '' ||newPass.value===' ' ||newPass.value===undefined||newPass.value===null)
    {
      this.messageFormNewPassreq = 'no';
      this.ErrorflagNewPass="no";

    }else if(newPass.value.match(this.regexpspace))
    {
      this.msgforNewPassSpace= 'no';
      this.ErrorflagNewPass="no";
    }else if(!newPass.value.match(this.regsplchar))
    {
      this.msgforNewPassSplChar= 'no';
      this.ErrorflagNewPass="no";
    }else if(newPass.value.length<8)
    {
      this.msgforNewPassLen = 'no';
      this.ErrorflagNewPass="no";
    }else if(newPass.value.length>16)
    {
      this.msgforNewPassLen = 'no';
      this.ErrorflagNewPass="no";
    }
    else if(!newPass.value.match(this.regexcap))
    {
      this.messageForOneCapital='no';
      this.ErrorflagNewPass="no";

    }
    else if(!newPass.value.match(this.regOneNum))
    {
      this.messageForOneNumber='no';
      this.ErrorflagNewPass="no";

    }else{
      this.ErrorflagNewPass="yes";
    }
  }


  clearNewPassword()
  {
    this.messageFormNewPassreq="";
    this.msgforNewPassSpace='';
    this.msgforNewPassSplChar="";
    this.msgforNewPassLen="";
    this.messageForOneCapital="";
    this.messageForOneNumber="";
  }

  validateOtp_Old()
  {
    let otp=this.forgotform.controls['otp'];
    if (otp.value === '' ||otp.value===' ' ||otp.value===undefined||otp.value===null)
    {
      this.msgOtprequired = 'no';
      this.ErrorflagOtp="no";

    }else if (otp.value.match(this.regexpspace))
    {
      this.msgOtpNoSpace = 'no';
      this.ErrorflagOtp="no";

    }
    else{
      this.ErrorflagOtp="yes";
    }

  }

  validateOtp() {
    this.otp=this.forgotform.controls['otp'].value;  
    // console.log('this.otp----'+this.otp);
   
    if (this.otp === undefined  || this.otp === '' || this.otp === null) {
      this.invalidOtp = 'no';
     return false;
    }else if (this.otp.match(this.reg)) {
      this.invalidOtp = 'specialChar';
      return false;
    }else if (!this.otp.match(this.regNum1)) {
      this.invalidOtp = 'num';
      return false;
    } else if (this.otp.length!=6) {
      this.invalidOtp = 'len';
      return false;
    }else{
      this.invalidOtp = '';
      return true;
    }
  }

  
  clearOtp()
  {
    this.invalidOtp = '';
    this.errorDescription='';
    this.Errorflag2="yes";
   
    this.msgOtprequired='';
  }


  getCaptcha () {
//$rootScope.counter = 180;
    var alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
      'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
      'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h',
      'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
      'u', 'v', 'w', 'x', 'y', 'z');
    var i;
    for (i = 0; i < 6; i++) {
      var a = alpha[Math.floor(Math.random() * alpha.length)];
      var b = alpha[Math.floor(Math.random() * alpha.length)];
      var c = alpha[Math.floor(Math.random() * alpha.length)];
      var d = alpha[Math.floor(Math.random() * alpha.length)];
      var e = alpha[Math.floor(Math.random() * alpha.length)];
      var f = alpha[Math.floor(Math.random() * alpha.length)];
      var g = alpha[Math.floor(Math.random() * alpha.length)];
    }
    var code = a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e + ' ' + f
      + ' ' + g;
    let captcha1= this.forgotform.controls['captcha'];
    captcha1.setValue(code);
  }
  validateCaptcha()
  {
    let captcha=this.forgotform.controls['captchaInput'];
    let captchaWithoutSpaceNew = this.forgotform.controls['captcha'].value.split(' ').join('');
    if (captcha.value === '' ||captcha.value===' ' ||captcha.value===undefined||captcha.value===null)
    {
      this.captchatNoblank = 'no';
      this.Errorflagcap="no";
    }else if(captcha.value!==captchaWithoutSpaceNew)
    {
      this.incorrectCaptcha='no';
      this.Errorflagcap="no";
    }else{
      this.Errorflagcap="yes";
    }
    console.log("Errorflagcap-----------"+this.Errorflagcap);
  }
  clearCaptcha()
  {
    this.captchatNoblank='';
    this.incorrectCaptcha='';
    this.isError='';
    console.log('captcha focus in:');
  }
  getMonthName(month)
  {
    return ["Jan","Feb","Mar","Apr","May","June","Jul","Aug","Sep", "Oct","Nov","Dec"][Number(month)-1];
  }
  changePlaceholder() {
    this.placeholder = 'Enter Date Of Birth';
  }

  onDateChanged(event: IMyDateModel) {
    //console.log("event date---"+JSON.stringify(event.formatted));
    let date1=JSON.stringify(event.formatted);
    //console.log("date1.length----"+date1.length+"date2"+date2+"date1"+date1+"@@@@"+date3);
    if(event==null){
      this.msgForDateRequired = 'no';
      this.Errorflagdate="no";
    }
    else if (date1==='""'||date1==='" "'||date1==='"  "' ||date1===undefined||date1===null)
    {
      this.msgForDateRequired = 'no';
      this.Errorflagdate="no";
    }else{
      this.Errorflagdate="yes";
      this.msgForDateRequired='';
    }

  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/forgot-password/forgot-password.component.ts